// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"DutyRosterToExcelExportModal_wrapper__1vnQ6","excelIcon":"DutyRosterToExcelExportModal_excelIcon__3s41I"};